module.exports = __webpack_public_path__ + "static/media/galerija_2022_0031.a62da7fe.jpg";